import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("cameroon",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5V20.5L0 20.5L0 4.5Z"
                fill="#CE1126" />
            <path
                d="M0 4.5L8 4.5L8 20.5L0 20.5L0 4.5Z"
                fill="#007A5E" />
            <path
                d="M16 4.5L24 4.5V20.5L16 20.5L16 4.5Z"
                fill="#FCD116" />
            <path
                d="M10.1209 14.958L15.0409 11.9196H8.96094L13.8809 14.958L12.0009 10.042L10.1209 14.958Z"
                fill="#FCD116" />
        </svg>
    `),e=i("cameroon_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66534)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="#CE1126" />
                <path
                    d="M0 0.5L8 0.5L8 24.5L0 24.5L0 0.5Z"
                    fill="#007A5E" />
                <path
                    d="M16 0.5L24 0.5L24 24.5L16 24.5L16 0.5Z"
                    fill="#FCD116" />
                <path
                    d="M10.1209 15.0598L15.0409 11.4998H8.96094L13.8809 15.0598L12.0009 9.2998L10.1209 15.0598Z"
                    fill="#FCD116" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66534">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Cameroon,e as CameroonRounded};
